import script from "./GeoInput.vue?vue&type=script&setup=true&lang=js"
export * from "./GeoInput.vue?vue&type=script&setup=true&lang=js"

import "./GeoInput.vue?vue&type=style&index=0&id=642948f6&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642948f6"]])

export default __exports__